<template>
  <div class="opc-license-number">
    <div class="opc-license-number__field">
      <div class="opc-license-number__field-left">
        <div class="opc-license-number__field-label-row">
          <label class="opc-license-number__field-label">{{ label || $t("billing.simplify.select_license") }}</label>
          <zm-tooltip
            v-if="tooltip"
            disallowLearnAbout
            placement="top"
            @input="handleTooltipInput"
          >
            <template #content>
              <span class="opc-zone__tip" v-html="tooltip"></span>
            </template>
            <zm-icon tabindex="0" :aria-label="`Learn more about ${label || $t('billing.simplify.select_license')}`">
              <Information />
            </zm-icon>
          </zm-tooltip>
        </div>
        <div class="opc-license-number__field-helper" v-if="helper">
          <p class="opc-license-number__field-helper-text">{{ helper }}</p>
        </div>
      </div>
      <div class="opc-license-number__field-right">
        <InputNumberWithPopover
          :modelValue="modelValue"
          @update:modelValue="handleInput"
          @change="handleChange"
          :min="min || 1"
          :max="max || 99"
          :disabled="disabled"
          size="large"
          controls-position="both"
          class="opc-license-number__counter"
          :label="`${title} Select the number of users`"
          :decrease-tips="decreaseTips"
          :increase-tips="increaseTips"
          :data-testid="dataTestid"
        />
        <user-changes :type="type" :unit="unit"/>
      </div>
    </div>
  </div>
</template>

<script>
import InputNumberWithPopover from "@/components/input-number/input-number-with-popover.vue";
import UserChanges from "@/components/users-change.vue";
import { InformationSmall as Information } from '@zoom/icons-vue';

export default {
  name: "LicenseNumber",
  components: {
    UserChanges,
    InputNumberWithPopover,
    Information
  },
  props: {
    type: String,
    unit: Number,
    // value: {
    //   type: Number,
    //   default: 1,
    // },
    modelValue: {
      type: Number,
      default: 1,
    },
    label: String,
    helper: String,
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 99,
    },
    tooltip: {
      type: String,
      default: "",
    },
    tooltipLabel: {
      type: String,
      default: "",
    },
    decreaseTips: {
      type: String,
      default: "",
    },
    increaseTips: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    trackingPlanKey: {
      type: String,
      default: "",
    },
    dataTestid: {
      type: String,
      default: '',
    },
  },
  emits: ["update:modelValue", "change"],
  methods: {
    handleInput(value) {
      this.$emit("update:modelValue", value);
    },
    handleChange(value) {
      this.$emit("change", value);
    },
    handleTooltipInput(tips) {
      // Event tracking for tooltip interaction
      if (tips && this.trackingPlanKey && this.$tracking) {
        this.$tracking.addOnBuyInteraction(
          `${this.trackingPlanKey} options`,
          "licenses - tooltip",
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/scss-utils';
@import '@/styles/variables';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-license-number {
  &__field {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 16px;

    @include media(mobile) {
      flex-direction: column;
    }
  }

  &__field-left {
    display: flex;
    flex: 1 0 0;
    flex-direction: column;
    gap: 2px;
  }

  &__field-right {
    display: flex;
    flex: 1 0 0;
    flex-direction: column;
    gap: 4px;
  }

  &__field-label-row {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__field-label {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.31px;
  }

  &__field-helper-text {
    font-size: 12px;
    line-height: 16px;
    color: var(--zoom-color-text-neutral, #686F79);
  }

  &__info-icon {
    width: 18px;
    height: 18px;
    color: var(--zoom-color-text-neutral, #686F79);
    cursor: pointer;
    flex-shrink: 0;
  }

  &__counter {
    width: 100%;

    & :deep(.opc-input-number__core) {
      width: 140px;
    }
  }

  &__change-tip {
    color: var(--zoom-color-text-neutral, #686F79);
    font-size: 12px;
    font-style: normal;
  }

  .opc-zone__tip b {
    font-weight: bold !important;
  }
}
</style>

